import React, { createContext, useContext, useState } from "react";

const AdminContext = createContext();

export const useAdminContext = () => {
  return useContext(AdminContext);
};

export const AdminProvider = ({ children }) => {
  const [users, setUsers] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  const handleEditUser = async (userId, updatedUserData, updatedPaymentData) => {
    try {
      const userResponse = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/users/${userId}`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(updatedUserData),
        }
      );

      if (!userResponse.ok) throw new Error("Erro ao atualizar usuário.");
      const updatedUser = await userResponse.json();

      setUsers((prevUsers) =>
        prevUsers.map((user) => (user.id === userId ? updatedUser : user))
      );

      const paymentResponse = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/payments/${userId}`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(updatedPaymentData),
        }
      );

      if (!paymentResponse.ok) throw new Error("Erro ao atualizar pagamento.");

      console.log("Usuário e pagamento atualizados com sucesso!");
    } catch (error) {
      console.error("Erro ao editar usuário:", error);
    }
  };

  return (
    <AdminContext.Provider
      value={{
        users,
        setUsers,
        modalOpen,
        setModalOpen,
        selectedUser,
        setSelectedUser,
        handleEditUser,
      }}
    >
      {children}
    </AdminContext.Provider>
  );
};
